module.exports = __webpack_public_path__ + "static/img/73 (2).027e664.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/73 (2).jpg
// module id = dWFU
// module chunks = 0